import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components/macro';

export interface ScAuthButtonsProps {
  horizontal?: boolean;
  hideRegBtn?: boolean;
}

export const ScAuthButtons = styled.div<ScAuthButtonsProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 8px;

  button {
    transition: all 0.4s ease;
    overflow: hidden;
    width: 100%;
  }

  svg {
    margin-right: 0;
    width: 16px;
    height: 16px;
    object-fit: contain;

    path {
      fill: #fff;
    }
  }

  ${({ horizontal, hideRegBtn }) =>
    horizontal &&
    css`
      width: 100%;
      display: grid;
      grid-template-columns: ${hideRegBtn ? '1fr' : '85px 1fr'};

      @media (${device.mobile}) {
        grid-template-columns: ${hideRegBtn ? '1fr' : '0.6fr 1fr'};
      }

      @media (${device.mobileXS}) {
        grid-template-columns: ${hideRegBtn ? '1fr' : '85px 1fr'};
      }
    `}

  @media (${device.mobile}) {
    margin-bottom: ${({ horizontal }) => (horizontal ? 0 : '32px')};
  }
`;
